<div class="layout-col full">
  <mat-toolbar elderTheme class="layout-row place-start-center gap-sm">
    <button mat-icon-button matDialogClose>
      <mat-icon>close</mat-icon>
    </button>

    <div class="layout-col">
      <span>{{ 'orders.prod.list.title' | translate }}: {{ workCenter?.name }}</span>
      <span class="mat-caption">{{ 'context.number' | translate }}: {{ workCenter?.number }}</span>
    </div>

    <span class="flex"></span>

    <span>{{ scheduleInterval | isoInterval }}</span>
  </mat-toolbar>

  <app-production-list
    class="flex"
    [enabledDisplayModes]="modes"
    [workCenterInput]="workCenter"
    [scheduleIntervalInput]="scheduleInterval"
    [prodListConfId]="prodListConfId"
    [scopes]="scopes"
  >
  </app-production-list>
</div>
